export const getRoundedNumber = (num: number) => {
  return Math.round(num * 100) / 100;
};
